import { createUseStyles } from 'react-jss';

import {
  AbsoluteBlackColors,
  AbsoluteWhiteColors,
} from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    overlay: {
      width: '100vw',
      height: '100dvh',
      overflow: 'hidden',
    },
    shell: {
      position: 'relative',
      width: '100vw',
      height: '100dvh',
      overflow: 'hidden',
      backgroundColor: AbsoluteBlackColors.base.default,
    },
    backButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      left: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    closeButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      left: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    muteButton: {
      position: 'absolute',
      top: `max(${Spacings.s12}, env(safe-area-inset-top))`,
      right: Spacings.s16,
      zIndex: StackingContext.layout,
    },
    iconButton: {
      width: Spacings.s40,
      height: Spacings.s40,
      flex: `0 0 ${Spacings.s40}`,
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      backdropFilter: 'blur(32px)',
      color: AbsoluteWhiteColors.base.default,
      border: [
        1,
        'solid',
        `color-mix(in srgb, ${AbsoluteWhiteColors.base.default} 20%, transparent)`,
      ],
    },
    scrollHintSlot: {
      position: 'absolute',
      left: '50%',
      bottom: `calc(${Spacings.s72} + ${Spacings.s24})`,
      transform: 'translateX(-50%)',
      zIndex: StackingContext.layout,
      pointerEvents: 'none',
    },
    hiddenFileInput: {
      display: 'none',
    },
  },
  { name: 'preset-feed' }
);

export default useStyles;
